import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxGalleryAnimation, NgxGalleryImageSize } from '@kolkov/ngx-gallery';

// @dynamic
@Component({
  selector: 'sc-image-preview-dialog',
  templateUrl: './sc-image-preview-dialog.component.html',
  styleUrls: ['./sc-image-preview-dialog.component.scss']
})
export class ScImagePreviewDialogComponent implements OnInit {
  galleryOptions = [
    {
      width: '600px',
      height: '500px',
      thumbnailsColumns: 4,
      imageAnimation: NgxGalleryAnimation.Fade,
      previewFullscreen: false,
      preview: false,
      imagePercent: 100,
      startIndex: this.data.startIndex,
      imageSize: NgxGalleryImageSize.Contain,
      thumbnails: this.data.urls.length > 1,
      imageSwipe: true,
      thumbnailSize: NgxGalleryImageSize.Contain,
      imageArrows: this.data.urls.length > 1,
      imageInfinityMove: true
    }
  ];
  constructor(
    public dialogRef: MatDialogRef<ScImagePreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { urls: [string]; startIndex: number }
  ) {}

  ngOnInit() {}
}
